import { createContext } from "react";

const websocketContext=createContext();

export default websocketContext;